import EmailIcon from '@material-ui/icons/Email';
//import EmailList from './EmailList';
import EmailEdit from './EmailEdit';
import {ListGuesser} from 'react-admin';

export default {
    list: ListGuesser,
    icon: EmailIcon,
    edit: EmailEdit,
};